// src/app/services/api.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { ApiRequestParams } from './client_library_objects.service';

import { environment } from '../../environments/environment';
export interface ApiResponse {
  data: any[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}


@Injectable({
  providedIn: 'root'
})
export class LibraryObjectsSerive {
  private baseUrl: string = `${environment['api_backend']}/api`
  private readonly http = inject(HttpClient);
  
  constructor() { }

  /**
     * Crea un nuevo objeto en la biblioteca.
     * @param data El objeto con los datos a enviar en el cuerpo de la petición.
     * @returns Un Observable que emite la respuesta de la API.
     */
  createLibraryObject(data: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}/library-objects/`, data);
  }
  updateLibraryObject(id: number, data: any): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${this.baseUrl}/library-objects/${id}`, data);
  }

  getLibraryObject(params: ApiRequestParams): Observable<ApiResponse> {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key as keyof ApiRequestParams];
        if (value !== null && value !== undefined) {
          if (Array.isArray(value)) {
            value.forEach(item => {
              httpParams = httpParams.append(key, item);
            });
          } else {
            httpParams = httpParams.set(key, value.toString());
          }
        }
      }
    }
    return this.http.get<ApiResponse>(`${this.baseUrl}/library-objects/clients`, { params: httpParams });
  }

  getLibraryObjectById(id: any): Observable<any> {
    const url = this.baseUrl + '/library-objects/' + id
    return this.http.get<any>(url);
  }

  getClients(params: any = {}): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/clients`, { params });
  }



  getModels(): Observable<any[]> {
    const params = { page: '1', limit: '1000' };
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<{ data: any[] }>(`${this.baseUrl}/models`, { params: httpParams })
      .pipe(
        map(response => response.data || [])
      );
  }

  getAttributesByType(attributeTypeName: string): Observable<any[]> {
    if (!attributeTypeName) {
      return of([]);
    }
    const params = { page: '1', limit: '1000', type: attributeTypeName };
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<{ data: any[] }>(`${this.baseUrl}/library-attributes`, { params: httpParams })
      .pipe(
        map(response => response.data || [])
      );
  }

  createAttribute(data: any): Observable<any[]> {
    return this.http.post<any>(`${this.baseUrl}/library-attributes/`, data);
  }
  updateAttribute(id: number, data: any): Observable<ApiResponse> {
    return this.http.patch<any>(`${this.baseUrl}/library-attributes/${id}`, data);
  }

  getAttributeTypes(): Observable<any[]> {
    const url = `${this.baseUrl}/library-attribute-types`;
    return this.http.get<{ data: any[] }>(url).pipe(
      map(response => response.data || [])
    );
  }

  uploadCsv(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(`${this.baseUrl}/library-objects/csv`, formData);
  }

  searchSemantic(dto: {text_query: string; filters?: any;}) {
  return this.http.post<any>(`${this.baseUrl}/library-objects/semantic`, dto
  );
}


}

// {
//   "library_attribute_type_id": 12,
//   "name": "line",
// },
// {
//   "library_attribute_type_id": 11,
//   "name": "sku",
// },
// {
//   "library_attribute_type_id": 10,
//   "name": "ean",
// },
// {
//   "library_attribute_type_id": 9,
//   "name": "size",
// },
// {
//   "library_attribute_type_id": 8,
//   "name": "shape"
// },
// {
//   "library_attribute_type_id": 7,
//   "name": "package"
// },
// {
//   "library_attribute_type_id": 6,
//   "name": "multi_package"
// },
// {
//   "library_attribute_type_id": 4,
//   "name": "flavor"
// },
// {
//   "library_attribute_type_id": 3,
//   "name": "company"
// },
// {
//   "library_attribute_type_id": 2,
//   "name": "category"
// },
// {
//   "library_attribute_type_id": 1,
//   "name": "brand"
// }